

<div class="modal-body final-statement">
  <table class="table" style="background-color:white;">

    <tr>
      <td style="background-color:#0f2b46;color:white;" colspan="2">Payment Confirmation </td>
      <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="null" (click)="closeModal(1)">close</mat-icon></td>
    </tr>
  </table>


  <div class="row align-items-center">
    <div class="col-12 text-center logo">
      <img src="{{currentUser.countrylogo}}" style="width: 254px" />
    </div>
    <div class="col-12 text-center checked">
      <img src="../../../../assets/Images/checked.svg" />

    </div>
    <div class="col-12 text-center currency">
      <table class="table table-hover text-center  table-bordered">

        <tr>
          <td style="font-weight:bold;">Reference Id :</td>
          <td>            {{data.eziPayReferenceId}}          </td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Amount :</td>
          <td>{{data.totalAmount}} {{UsertBal.currency}}</td>
        </tr>
        <tr>
          <td style="font-weight:bold;">Transaction Date :</td>
          <td>{{data.entryDate|date}}</td>
        </tr>



      </table>
      <!-- <div class="col-12 text-center success">
       <p>Pay Money Successfully.</p>
          <h3>{{data.ToMobileNo}}</h3>
      </div>

      <div class="col-12 text-center updated">
          <p>Updated Wallet Balance: <i _ngcontent-vdj-c2="" class="icon-ghana"></i> {{data.CurrentBalance}} </p>
      </div>-->
      <!--<div class="col-12 text-center back">
          <p (click)="closeModal(2)">Back To Home</p>
      </div>
      </div>-->



    </div>

  </div>
</div>
